[<template>
  <div class="pre-checkout">
    <product-gallery :first-name="firstName"
                     :monthly-deposit-sum="monthlyDepositSum" />
    <div class="dry-details r-text-headline-paragraph">
      <div class="info">
        <div class="r-text-intro">ההפקדות שלך</div>
        <div>
          <span>חודשית </span>
          <span class="r-text-bold">{{ formatAmount(monthlyDepositSum) }} ₪</span>
        </div>
        <div class="info" v-if="showOneTimeDeposit">
          <span>חד פעמית </span>
          <span class="r-text-bold">{{ formatAmount(oneTimeDepositSum) }} ₪</span>
        </div>
      </div>
      <div class="info">
        <div class="r-text-intro">דמי ניהול</div>
        <div>{{ COMMISSION_IN_PERCENTAGE }}% מצבירה בלבד*</div>
      </div>
      <div class="info">
        <div>
          <div class="r-text-intro">מסלול השקעה</div>
          <div>כללי ב׳מיטב׳**</div>
        </div>
      </div>

    </div>

    <default-button label="לרכישה" @click="next" :disable="locked" :loading="locked" />
    <div style="margin-top: 14px">
      *עלות שנתית צפויה במסלול מיטב גמל לההשקעה כללי היא {{YEARLY_TOTAL_EXPECTED_FEES_IN_PERCENTAGE}}%.
      הצגת שיעור העלות השנתית הצפויה מהווה תחזית בלבד,
      ומבוססת על מגוון רחב של הנחות אשר חלקן מבוסס על נתוני שנים קודמות ועל נוסחת המרה אחידה,
      ואשר כולן נערכו בהתבסס על המידע שהיה זמין לגוף המוסדי בתחילת שנת הדיווח
      שבגינה מוצגת העלות השנתית הצפויה ובהתאם לנתונים האמורים.
      שיעור ההוצאות הישירות הצפוי בשל ביצוע השקעות מוצג לכל מסלול השקעה
      ובהתאם לצבירה בכל מסלול השקעה יחסית לצבירה הכוללת בכל מסלולים. אי לכך, אין בהצגה זו
      בכדי לחייב את הגוף המוסדי לגביית עלויות בהתאם לשיעור העלות השנתית הצפויה,
      וכי השיעור בפועל ייקבע בין היתר, בהתאם להשקעות שיבוצעו במהלך השנה,
      לתשואות שיושגו במהלך השנה על נכסי העמיתים במסלול ההשקעה ובהתאם
      לסך המשיכות וההפקדות שיבוצעו בחשבון במהלך השנה.
      כמו כן, הגוף המוסדי אינו מחויב בעדכון או שינוי שיעור העלות השנתית הצפויה על מנת לשקף אירועים או נסיבות שיחולו לאחר הצגתו.
    </div>
    <div>
      ** הוצאות ניהול השקעות {{YEARLY_MGMT_EXPECTED_FEES_IN_PERCENTAGE}}%.
      הוצאות ניהול השקעות מחושבות בהתאם למסלול ולהוצאות שנגבו בפועל, ובשיעור אחיד עבור כל עמיתי מסלול ההשקעה הנבחר.
    </div>
    <div>התנאים המלאים מופיעים <link-button
      class="tc-link-button"
      text="באתר מיטב"
      @click="fullTerms"/></div>
  </div>
</template>

<script>
import _ from 'lodash';
import Segment from '@/Segment';
import { mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import DefaultButton from '@/components/styled/DefaultButton';
import {
  COMMISSION_IN_PERCENTAGE,
  YEARLY_MGMT_EXPECTED_FEES_IN_PERCENTAGE,
} from '@/constants/meitav-dash/open-fund';
import Uplift from '@/views/meitav-dash/open-fund/dialogs/Uplift';
import MoneyFormat from '@/mixins/MoneyFormat';
import ProductGallery from '@/components/meitav-dash/open-fund/kgl-carousel/ProductGallery';
import LinkButton from '@/components/base/LinkButton';

export default {
  name: 'PreCheckout',
  components: { LinkButton, ProductGallery, DefaultButton },
  mixins: [WizardPage, MoneyFormat],
  computed: {
    ...mapState('meitavDash/openFund', ['monthlyDepositSum', 'firstName', 'oneTimeDepositSum', 'showUpliftDialog']),
    COMMISSION_IN_PERCENTAGE() {
      return COMMISSION_IN_PERCENTAGE;
    },
    YEARLY_MGMT_EXPECTED_FEES_IN_PERCENTAGE() {
      return YEARLY_MGMT_EXPECTED_FEES_IN_PERCENTAGE;
    },
    YEARLY_TOTAL_EXPECTED_FEES_IN_PERCENTAGE() {
      return (COMMISSION_IN_PERCENTAGE + YEARLY_MGMT_EXPECTED_FEES_IN_PERCENTAGE).toFixed(2);
    },
    showOneTimeDeposit() {
      return !_.isNil(this.oneTimeDepositSum) && this.oneTimeDepositSum > 0;
    },
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setUpliftDialogShown']),
    next() {
      if (this.showUpliftDialog) {
        this.$q.dialog({
          component: Uplift,
          parent: this,
          firstName: this.firstName,
        }).onDismiss(() => {
          this.setUpliftDialogShown();
          this.nextPage();
        });
      } else {
        this.nextPage();
      }
    },
    openQuestionsAndAnswers() {
      Segment.trackUserInteraction('Saving_QAClicked');
      window.open('/pdfs/riseup_Q&A.pdf', '_blank');
    },
    fullTerms() {
      Segment.trackUserInteraction('Saving_FullTerms_Meitav');
      window.open('https://www.meitav.co.il/provident_pension/provident_invest/', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.product-gallery {
  margin-bottom: 36px;
}

.dry-details {
  margin-top: 32px;
  .info {
    margin-bottom: 16px;
  }
}

</style>
